module.exports = __webpack_public_path__ + "img/gb9116_14_a.prt.23920292.jpg";